import React, { Dispatch, SetStateAction } from "react";
import Dialog from "../../../../ui/widgets/dialog";
import Typography from "../../../../ui/widgets/typography";
import { useMessageSource } from "react-message-source";
import CancelReason from "./cancel-reason";
import { CancelReasonModel } from "./types";
import IconButton from "../../../../ui/widgets/button-icon";
import { CancellationCase } from "../../../../context/cancelApplicationContext";

export default function CancelCardholderApplication({
  cancellationCase,
  setCancelDialogActive,
  cancelApplicationCallback,
}: {
  cancellationCase: CancellationCase;
  setCancelDialogActive: Dispatch<SetStateAction<boolean>>;
  cancelApplicationCallback: (values: CancelReasonModel) => void;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <Dialog open={true} maxWidth={"lg"}>
      <div className="scd-dialog-header">
        <Typography variant="h2">
          {getMessage("CancelApplication.card-application.title")}
        </Typography>
        <IconButton
          onClick={() => setCancelDialogActive(false)}
          title="Close"
          icon="close"
        />
      </div>
      <Typography variant="body1" className="scd-container-base">
        {getMessage("CancelApplication.card-application.text")}
      </Typography>
      <CancelReason
        cancellationCase={cancellationCase}
        cancelApplicationCallback={cancelApplicationCallback}
      />
    </Dialog>
  );
}
